"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 62: Super 700-in-1 (pirate multicart)
 * ------------------------------------------------------------------ */
// 700-in-1

function register(Mappers) {
  Mappers[62] = function (nes) {
    this.nes = nes;
  };

  Mappers[62].prototype = new Mappers[0]();

  Mappers[62].prototype.write = function (address, value) {
    if (address < 0x8000) {
      Mappers[0].prototype.write.apply(this, arguments);
      return;
    }

    // Unlike almost every other board, the cart encodes a whole register
    // write in the ADDRESS it is written to, any address $8000-$FFFF, with
    // only the low two bits of the CHR page coming from the data byte:
    //
    //   A~[..pp pppp MPOC CCCC]   data value D~[.... ..cc]
    //
    //     p (A13-A8)  low six bits of the PRG page
    //     P (A6)      seventh bit of the PRG page (skips A7!)
    //     O (A5)      PRG mode: 0 = 32 KB pair, 1 = one 16 KB page twice
    //     C (A4+A3-0) high five bits of the CHR page (7 bits total)
    //     M (A7)      mirroring: 0 = vertical, 1 = horizontal
    //     c (D1-D0)   low two bits of the CHR page
    //
    // Mesen's Mapper62 (Core/Mapper62.h) agrees with Disch's notes bit for
    // bit, and that is where this decoding comes from.
    var prgPage = ((address & 0x3f00) >> 8) | (address & 0x40);
    var chrPage = ((address & 0x1f) << 2) | (value & 0x03);

    if (address & 0x20) {
      // Mode 1: the same 16 KB page occupies both windows.
      this.loadRomBank(prgPage, 0x8000);
      this.loadRomBank(prgPage, 0xc000);
    } else {
      // Mode 0: the even/odd 16 KB pair covers $8000-$FFFF as one 32 KB
      // block. The pair uses the page number with its last bit cleared.
      this.loadRomBank(prgPage & 0xfe, 0x8000);
      this.loadRomBank((prgPage & 0xfe) + 1, 0xc000);
    }

    // One 8 KB CHR page, mirrored through both pattern tables.
    this.load8kVromBank(chrPage * 2, 0x0000);

    this.setMirroring(
      address & 0x80
        ? this.nes.rom.HORIZONTAL_MIRRORING
        : this.nes.rom.VERTICAL_MIRRORING,
    );
  };

  Mappers[62].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("700-in-1: Invalid ROM! Unable to load.");
    }

    this.reset();
    // Mesen powers the board on with PRG pages 0 and 1, not with the last
    // bank fixed at the top: this is a menu multicart, and the menu lives in
    // the early banks. The first register write re-maps everything anyway.
    this.loadRomBank(0, 0x8000);
    this.loadRomBank(1, 0xc000);
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.resetIrqHandler();
  };

  // Everything the board does lives in the address of the write itself, so
  // there is no register state to save: the bank mapping and the mirroring
  // (PPU side) are reloadable from the ROM, and nothing else lasts.
}

module.exports = { register: register };
